<div class="modal-header">
  <h4 class="modal-title" id="modal-title">Abrechnung {{Entry()?.key}} ({{Entry()?.versicherungsnummer}}) {{Entry()?.month}} / {{Entry()?.year}}</h4>
  <button type="button"
          class="btn-close"
          aria-describedby="modal-title"
          (click)="modal.dismiss('Cross click')"></button>
</div>
<div class="modal-body" style="max-height: Calc(90vh - 50px);" >
  <div class="row" >
    <div class="col">
      <div class="card Card">
        <h3>Abrechnung</h3>
        <div class="card-body">
          <div class="row">
            <div class="col">
              <div class="form-floating mb-3">
                <select class="form-select "
                        id="Status"
                        [(ngModel)]="Entry().status" (ngModelChange)="Entry().status = $event">
                  <option *ngFor="let item of StatusData" [ngValue]="item.key">
                    {{ item.Bezeichnung }}
                  </option>
                </select>
                <label for="Status">Status</label>
              </div>

              <div class="form-floating mb-3">

                <AbsetzungGrundSelect [(Text)]="Entry().freitext_A" [(selection)]="Entry().grund" )]></AbsetzungGrundSelect>

              </div>
              <div class="form-floating mb-3">
                <textarea type="text"  class="form-control" id="freitext_B" [(ngModel)]="Entry().freitext_B"></textarea>
                <label for="freitext_B">Freitext B</label>
              </div>
              <div class="row">
                <div class="col">
                  <div class="btn btn-primary w-100 mt-2 mb-2" (click)="save()">Speichern</div>
                </div>
              </div>
            </div>
            <div class="col-4">
              <absetzungs-dateien [Absetzung]="Entry()"></absetzungs-dateien>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="card Card">
        <h3>Infos</h3>
        <div class="card-body">
          <div class="row">
            <div class="col">
              <div class="form-floating mb-3">
                <input type="text"  class="form-control" id="Name" value="{{Entry().firstName}} {{Entry().lastName}} ({{Entry().versicherungsnummer}})" disabled readonly>
                <label for="Name">Versicherten Name</label>
              </div>
            </div>
            <div class="col">
              <div class="form-floating mb-3">
                <input type="text"  class="form-control" id="birthday" value="{{Entry().birthday | date:'dd.MM.yyyy'}}" disabled readonly>
                <label for="birthday">Gebutsdatum</label>
              </div>
            </div>
            <div class="col">
              <div class="form-floating mb-3">
                <div class="form-control" id="phonenumber" style="background-color: #e9ecef;"  disabled readonly>
                  <PhoneCall  [number]="Entry().phonenumber ?? ''"></PhoneCall>
                </div>
                <label for="phonenumber">Tel. Nummer</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="form-floating mb-3">
                <input type="text"  class="form-control" id="kassenName" [ngModel]="Entry().kassenName" disabled readonly>
                <label for="kassenName">Kasse</label>
              </div>
            </div>
            <div class="col">
              <div class="form-floating mb-3">
                <input type="text"  class="form-control" id="genehmigungsNr" [ngModel]="Entry().genehmigungsNr" disabled readonly>
                <label for="genehmigungsNr">Genehmigungsnummer</label>
              </div>
            </div>
            <div class="col"></div>
          </div>
          <div class="row">
            <div class="col">
              <div class="form-check mb-3">
                <input name="isGKV" id="isGKV" class="form-check-input" type="checkbox" disabled readonly
                       [checked]="Entry().isGKV"
                       />
                <label for="isGKV" class="form-check-label">Ist GKV</label>
              </div>
            </div>
            <div class="col">
              <div class="form-check mb-3">
                <input name="beihilfe" id="beihilfe" class="form-check-input" type="checkbox" disabled readonly
                       [checked]="Entry().beihilfe"
                />
                <label for="beihilfe" class="form-check-label">Beihilfe</label>
              </div>
            </div>
            <div class="col"></div>
          </div>
          <div class="row">
            <div class="col">
              <div class="form-floating mb-3">
                <input type="text"  class="form-control" id="ruekholungAm" value="{{Entry().ruekholungAm | date:'dd.MM.yyyy' }}" disabled readonly>
                <label for="ruekholungAm">Rückholung</label>
              </div>
            </div>
            <div class="col">
              <div class="form-floating mb-3">
                <input type="text"  class="form-control" id="ruekholungGrund" [ngModel]="Entry().ruekholungGrund" disabled readonly>
                <label for="ruekholungGrund">Rückholung Grund</label>
              </div>
            </div>
            <div class="col">
              <div class="row">
                <div class="col"></div>
                <div class="col-auto">
                  <div class="btn btn-primary" (click)="OpenAkten()">Akte</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

          <div class="row" >
            <div class="col">
              <div class="card Card">
                <h3>Absetzungen</h3>
                <div class="card-body">
                  <Absetzung [SelectedChanged]="Entry.set" [DisableUrlFilter]="true" [HideHeader]="true"  [Customer]="Entry().versicherungsnummer" [FilterID]="Entry().key" ></Absetzung>
                </div>
              </div>
            </div>
          </div>


</div>


<ng-template #successVerTpl> Aktion erfolgreich! </ng-template>
<ng-template #FaildVerTpl> Aktion fehlgeschlagen! </ng-template>
